import {FC, ReactNode, useState} from "react";
import {User, UserContactType} from "../../types/domain.ts";
import {useUserContacts} from "../../queries/useUserContacts.ts";
import {Descriptions, Empty, Flex, Popover, Spin, Typography} from "antd";
import styles from './UserWithContacts.module.css'
import {CONTACT_TYPE_TO_LABEL, ROLE_MAP} from "../../constants/constants.ts";
import {LinkWithCopy} from "../LinkWithCopy/LinkWithCopy.tsx";
import {isFirManager, isFirReader, isStaff} from "../../utils/userTypeGuards.ts";

type Props = {
    user: User;
}

export const CONTACT_RENDER_FUNCTIONS: Record<UserContactType, (v: string) => ReactNode> = {
    telegram: (v) => <Typography.Link href={`https://t.me/${v}`} target="_blank">@{v}</Typography.Link>,
    discord: (v) => <Typography.Link href={`https://discord.com/users/${v}`} target="_blank">@{v}</Typography.Link>,
    wa: (v) => <LinkWithCopy>{v}</LinkWithCopy>,
    tel: (v) => <LinkWithCopy>{v}</LinkWithCopy>,
    email: (v) => <Typography.Link href={`mailto:${v}`} target="_blank">{v}</Typography.Link>,
}

export const UserWithContacts: FC<Props> = ({ user }) => {
    const [open, setOpen] = useState(false);

    const { data, isLoading } = useUserContacts(user.id, open);
    const sortedData = [...(data || [])].sort((a, b) => {
        if (a.primary && !b.primary) return -1;
        if (!a.primary && b.primary) return 1;
        return 0;
    });

    const popoverContent = (
        <div className={styles.popoverContent}>
            {isLoading ? <Spin /> : (
                <Flex vertical gap={6}>
                    <Flex vertical>
                        <Typography.Title level={5}>{user.first_name} {user.last_name}</Typography.Title>
                        <Typography.Text>{ROLE_MAP[user.role]} {!isStaff(user) && `(${isFirManager(user) || isFirReader(user) ? user.firs.map(({ name }) => name).join(', ') : (user as User & { role: 'region_manager' }).region.name})`}</Typography.Text>
                    </Flex>
                    {sortedData.length ? (
                        <Descriptions
                            className={styles.contactsDescription}
                            column={1}
                            items={sortedData.map(({ type, value, primary }) => ({
                                label: CONTACT_TYPE_TO_LABEL[type],
                                children: <Flex gap={4}>{CONTACT_RENDER_FUNCTIONS[type](value)} {primary ? `(основной)` : ''}</Flex>
                            }))}
                        />
                    ) : (
                        <Empty
                            image={Empty.PRESENTED_IMAGE_SIMPLE}
                            description="Контакты пока не заданы"
                        />
                    )}
                </Flex>
            )}
        </div>
    )

    return (
        <Popover trigger='click' placement='leftTop' open={open} onOpenChange={setOpen} content={popoverContent}>
            <span className={styles.text}>
                {user.first_name} {user.last_name}
            </span>
        </Popover>
    )
}